import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appModalContent]',
    standalone: false
})
export class ModalContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
